window.TRANSLATE = {
  language: Object.keys(JSON_LOCALES)[0],
  text: JSON_LOCALES[ Object.keys(JSON_LOCALES)[0] ]
};



// WEBPACK FOOTER //
// ./src/assets/javascripts/locales.js